<template>
    <div class="modal" tabindex="-1" role="dialog" id="muven-dashboard-monitoring-modal">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Monitoramento</h5>
                </div>
                <div class="modal-body">
                    <div class="row" v-show="hasMoreThanOneStore">
                        <ul class="nav nav-tabs" id="credentials-tabs-container">
                            <li class="nav-item">
                                <a class="nav-link active" data-toggle="tab" href="#monitoring-general">Geral</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#monitoring-by-store">Por Loja</a>
                            </li>
                        </ul>
                    </div>

                    <div class="tab-content">
                        <div class="tab-pane fade show active" id="monitoring-general">
                            <transition name="reveal" mode="out-in">
                            <MonitoringAnalyzingCmp v-if="loadingGeneral" key="loading"
                                :phrases="generalPhrases" />

                            <div v-else-if="errorGeneral" key="error" class="monitoring-error">
                                <p class="monitoring-error-title">Não foi possível analisar agora</p>
                                <p class="monitoring-error-text">Verifique sua conexão e tente de novo.</p>
                                <button type="button" class="btn btn-outline-secondary btn-sm mt-3"
                                    @click="loadGeneral()">
                                    Tentar novamente
                                </button>
                            </div>

                            <div v-else key="content" class="row monitoring-reveal">
                                <div class="col-12 col-lg-6 pl-0">
                                    <div class="muven-card">
                                        <div class="muven-card-title">
                                            <p>Integração com a retaguarda</p>
                                        </div>

                                        <div class="monitoring-entity-integration-information-container">
                                            <div class="entity-information-item" 
                                                v-for="(info, index) in statusesInformationBackend" :key="index"
                                                :class="{
                                                    'entity-normal': info.isStatusNormal(),
                                                    'entity-warning': info.isStatusWarning(),
                                                    'entity-not-working': info.isStatusNotWorking(),
                                                }">
                                                <p class="entity-information-description">
                                                    <fa icon="check-circle" class="entity-status-icon" v-if="info.isStatusNormal()"/>
                                                    <fa icon="exclamation-triangle" class="entity-status-icon" v-if="info.isStatusWarning()"/>
                                                    <fa icon="exclamation-triangle" class="entity-status-icon" v-if="info.isStatusNotWorking()"/>
                                                    <span>{{info.description}}</span>                        

                                                    <router-link 
                                                    v-if="info.hasLink()"
                                                    :to="info.link" 
                                                    class="btn btn-link">
                                                    Detalhe
                                                        <fa icon="external-link-alt" class="muven-external-link ml-1" />
                                                    </router-link>
                                                </p>
                                                <p class="entity-information-message text-muted">{{info.message}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-6 pr-0">
                                    <div class="muven-card">
                                        <div class="muven-card-title">
                                            <p>Integração com o canal</p>
                                        </div>

                                        <div class="monitoring-entity-integration-information-container">
                                            <div class="entity-information-item" 
                                                v-for="(info, index) in statusesInformationChannel" :key="index"
                                                :class="{
                                                    'entity-normal': info.isStatusNormal(),
                                                    'entity-warning': info.isStatusWarning(),
                                                    'entity-not-working': info.isStatusNotWorking(),
                                                }">
                                                <p class="entity-information-description">
                                                    <fa icon="check-circle" class="entity-status-icon" v-if="info.isStatusNormal()"/>
                                                    <fa icon="exclamation-triangle" class="entity-status-icon" v-if="info.isStatusWarning()"/>
                                                    <fa icon="exclamation-triangle" class="entity-status-icon" v-if="info.isStatusNotWorking()"/>
                                                    <span>{{info.description}}</span>                        

                                                    <router-link 
                                                    v-if="info.hasLink()"
                                                    :to="info.link" 
                                                    class="btn btn-link">
                                                    Detalhe
                                                        <fa icon="external-link-alt" class="muven-external-link ml-1" />
                                                    </router-link>
                                                </p>
                                                <p class="entity-information-message text-muted">{{info.message}}</p>
                                            </div>

                                            <div class="entity-information-item entity-neutral" v-if="!statusesInformationChannel.length">
                                                <p class="entity-information-description description-without-icon">
                                                    <span class="text-muted">Nenhuma informação disponível</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </transition>
                        </div>

                        <div class="tab-pane fade show" id="monitoring-by-store">
                            <transition name="reveal" mode="out-in">
                            <MonitoringAnalyzingCmp v-if="loadingByStore" key="loading"
                                title="Analisando lojas"
                                :phrases="byStorePhrases" />

                            <div v-else-if="errorByStore" key="error" class="monitoring-error">
                                <p class="monitoring-error-title">Não foi possível analisar as lojas agora</p>
                                <p class="monitoring-error-text">Verifique sua conexão e tente de novo.</p>
                                <button type="button" class="btn btn-outline-secondary btn-sm mt-3"
                                    @click="loadByStore()">
                                    Tentar novamente
                                </button>
                            </div>

                            <div v-else key="content" class="store-info-container">
                                <table class="table table-sm table-striped">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>Id retaguarda</th>
                                            <th>Atualização estoque</th>
                                            <th>Atualização pedido</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(storeInfo, index) in statusesByStoreInformation" :key="index">
                                            <td>{{storeInfo.name}}</td>
                                            <td>{{storeInfo.idSource}}</td>
                                            <td>
                                                <span>{{storeInfo.lastConnectionStore | dateTimeFilter}}</span>         

                                                <span v-show="storeInfo.hasConnectionStock() && !storeInfo.hasBeenAWhileSinceConnectionStock()">
                                                    <fa icon="check-circle" class="text-success ml-3"/>
                                                </span>

                                                <span v-show="storeInfo.hasConnectionStock() && storeInfo.hasBeenAWhileSinceConnectionStock()">
                                                    <fa icon="exclamation-triangle" class="text-warning ml-3"/>
                                                </span>

                                                <span v-show="!storeInfo.hasConnectionStock()">
                                                    <span>Sem conexão</span>
                                                    <fa icon="exclamation-triangle" class="text-danger ml-3"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span>{{storeInfo.lastConnectionOrder | dateTimeFilter }}</span>

                                                <span v-show="storeInfo.hasConnectionOrder() && !storeInfo.hasBeenAWhileSinceConnectionOrder()">
                                                    <fa icon="check-circle" class="text-success ml-3"/>
                                                </span>

                                                <span v-show="storeInfo.hasConnectionOrder() && storeInfo.hasBeenAWhileSinceConnectionOrder()">
                                                    <fa icon="exclamation-triangle" class="text-warning ml-3"/>
                                                </span>

                                                <span v-show="!storeInfo.hasConnectionOrder()">                                                    
                                                    <span>Sem conexão</span>
                                                    <fa icon="exclamation-triangle" class="text-danger ml-3"/>                                                    
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>                                        
                                </table>
                            </div>
                            </transition>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" 
                        class="btn btn-outline-secondary" 
                        @click="close()">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import serviceStatusService from '@/monitoring/services/ServiceStatusInformationService'
import MonitoringAnalyzingCmp from '@/monitoring/components/MonitoringAnalyzingCmp'
import modalService from '../../utils/services/ModalService'
import { dateTimeFilter } from "../../utils/filters/DateTimeFilter"
import { infoOrPlaceholder } from "../../utils/filters/InformationOrPlaceholderFilter"
import { mapGetters } from 'vuex'

const ID_MONITORING_MODAL = '#muven-dashboard-monitoring-modal'

export default {
    name: 'MonitoringCmp',
    components: {
        MonitoringAnalyzingCmp,
    },
    filters: {
        dateTimeFilter,
        infoOrPlaceholder,
    },
    data() {
        return {
            statusesInformation: [],
            statusesByStoreInformation: [],
            loadingGeneral: false,
            loadingByStore: false,
            errorGeneral: false,
            errorByStore: false,
            // Cada abertura ganha um id: respostas de uma abertura anterior são descartadas.
            requestId: 0,
            generalPhrases: [
                'Verificando a retaguarda...',
                'Consultando os canais...',
                'Conferindo os pedidos...',
            ],
            byStorePhrases: [
                'Lendo a última conexão de cada loja...',
                'Conferindo estoque e pedidos...',
            ],
        }
    },
    methods: {
        /**
         * Abre o modal na hora e carrega em seguida. Com `prefetched` (a lista que a
         * Central acabou de buscar) a aba Geral já nasce preenchida e só é
         * atualizada em silêncio.
         */
        show(prefetched) {
            this.requestId++

            $('a[href="#monitoring-general"]').tab('show');

            const hasPrefetched = Array.isArray(prefetched)

            if (hasPrefetched) {
                this.statusesInformation = prefetched
            }

            this.loadGeneral({ silent: hasPrefetched })

            if (this.hasMoreThanOneStore) {
                this.loadByStore()
            } else {
                this.statusesByStoreInformation = []
            }

            modalService.show(ID_MONITORING_MODAL)
        },
        async loadGeneral({ silent = false } = {}) {
            const requestId = this.requestId

            if (!silent) {
                this.loadingGeneral = true
            }

            this.errorGeneral = false

            try {
                const statuses = await serviceStatusService.getServiceStatusInformation()

                if (requestId === this.requestId) {
                    this.statusesInformation = statuses
                }
            } catch (e) {
                // Na atualização silenciosa os dados da Central continuam valendo.
                if (requestId === this.requestId && !silent) {
                    this.errorGeneral = true
                }
            }

            if (requestId === this.requestId) {
                this.loadingGeneral = false
            }
        },
        async loadByStore() {
            const requestId = this.requestId

            this.loadingByStore = true
            this.errorByStore = false

            try {
                const statuses = await serviceStatusService.getServiceStatusInformationByStore()

                if (requestId === this.requestId) {
                    this.statusesByStoreInformation = statuses
                }
            } catch (e) {
                if (requestId === this.requestId) {
                    this.errorByStore = true
                }
            }

            if (requestId === this.requestId) {
                this.loadingByStore = false
            }
        },
        close() {
            modalService.hide(ID_MONITORING_MODAL)
        },
    },
    computed: {
        ...mapGetters([
            'hasMoreThanOneStore',
        ]),
        statusesInformationBackend() {
            return this.statusesInformation.filter((s) => {
                return s.isSourceBackend()
            })
        },
        statusesInformationChannel() {
            return this.statusesInformation.filter((s) => {
                return s.isSourceChannel()
            })
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../styles/monitoring.scss";

.monitoring-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 260px;
    text-align: center;

    p {
        margin-bottom: 0;
    }

    .monitoring-error-title {
        font-weight: 600;
        color: var(--text);
    }

    .monitoring-error-text {
        margin-top: 4px;
        font-size: .85em;
        color: var(--text-faint);
    }
}

// Conteúdo chega com um assentamento curto, não aparece de supetão.
.reveal-enter-active,
.reveal-leave-active {
    transition: opacity .22s ease, transform .22s ease;
}

.reveal-enter {
    opacity: 0;
    transform: translateY(6px);
}

.reveal-leave-to {
    opacity: 0;
}

// Os dois cards da aba Geral entram em sequência.
.reveal-enter-active.monitoring-reveal > div {
    animation: reveal-card .32s ease both;

    & + div {
        animation-delay: .06s;
    }
}

@keyframes reveal-card {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: none; }
}

@media (prefers-reduced-motion: reduce) {
    .reveal-enter-active,
    .reveal-leave-active {
        transition: none;
    }

    .reveal-enter-active.monitoring-reveal > div {
        animation: none;
    }
}
</style>
